module.exports = __webpack_public_path__ + "static/media/presentation.4ef9a03c.pptx";